'use strict';

import coreProduct from '*/index';
import {initMethods} from '../helpers/utilities';
import storePickup from '../storePickup/storePickup';
import productStorePickup from './productStorePickup';

initMethods(storePickup);
initMethods(productStorePickup);

export default coreProduct;
